enum DocumentDialogStates {
  INITIAL = 'INITIAL',
  EDITOR = 'EDITOR',
  PREVIEW = 'PREVIEW',
}

export default DocumentDialogStates
